import { Button } from 'react-bootstrap'
import { Alert } from '../../../components/alerts/Alert'
import { TActualizarClave, useActualizarClaveForm } from '../models/actualizarClaveFormType'
import { SubmitHandler } from 'react-hook-form'
import { useActualizarClaveMutation } from '../../../redux/api'
import { FormInputPassword } from '../../../components/forms/input/FormInputPassword'
import { useEffect } from 'react'
import { alertUsuarios } from '../../usuarios/components'
import { alertSuccess } from '../../../utils/alerts/AlertSuccess'
import { resetOption } from '../../../redux/slices/perfil'
import { useDispatch } from 'react-redux'
import { Cargando } from '../../../components/layout/Cargando'

export const ActualizarClave = () => {
  const dispatch = useDispatch()
  const formActulizarClave = useActualizarClaveForm()
  const [actualizarClave, { isLoading }] = useActualizarClaveMutation()
  const {
    register,
    formState: { errors },
    reset,
    handleSubmit,
    setError,
    clearErrors,
  } = formActulizarClave

  useEffect(() => {
    return () => {
      dispatch(resetOption())
    }
  }, [])

  /**
   * @description Submit para formulario de actualizar clave, comprueba si la clave nueva y la confirmación coinciden,
   *
   * @author andres.martinez, Hábil MX
   * @version 1.0.0, 04/05/2023
   * @param data Claves provenientes del formulario
   */
  const onSubmit: SubmitHandler<TActualizarClave> = (data: TActualizarClave) => {
    if (data.claveNuevaConfirmacion === data.claveNueva) {
      clearErrors()
      actualizarClave(data)
        .unwrap()
        .then(() => {
          alertSuccess('Contraseña actualizada', 'La contraseña ha sido actualizada con exito.')
          reset({ claveActual: '', claveNueva: '', claveNuevaConfirmacion: '' })
        })
        .catch((err) => {
          alertUsuarios(true, handleSubmit, err)
        })
    } else {
      setError('claveNueva', {
        type: 'manual',
        message: 'Las contraseñas no coinciden. Vuelve a intentarlo',
      })
      setError('claveNuevaConfirmacion', {
        type: 'manual',
        message: 'Las contraseñas no coinciden. Vuelve a intentarlo',
      })
    }
  }

  return (
    <>
      <div className='h-125px d-flex flex-column justify-content-center'>
        <h1>Actualizar contraseña</h1>
      </div>
      <div>
        <div className='row'>
          <div className={`col-sm-5 p-5 ${isLoading ? 'overlay overlay-block' : ''}`}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormInputPassword
                className='mb-5'
                nombre='Contraseña actual'
                nombreCampo='claveActual'
                isObligatorio={true}
                register={register}
                errors={errors}
                placeholder='Contraseña actual'
                disabled={isLoading}
              />
              <FormInputPassword
                className='mb-5'
                nombre='Nueva contraseña'
                nombreCampo='claveNueva'
                isObligatorio={true}
                register={register}
                errors={errors}
                placeholder='Nueva contraseña'
                disabled={isLoading}
              />
              <FormInputPassword
                className='mb-5'
                nombre='Confirmar contraseña'
                nombreCampo='claveNuevaConfirmacion'
                isObligatorio={true}
                register={register}
                errors={errors}
                placeholder='Confirmar contraseña'
                disabled={isLoading}
              />
              <div className='d-flex align-items-center'>
                <div className='mt-8'>
                  <Button disabled={isLoading} type='submit'>
                    Aceptar
                  </Button>
                  <button type='reset' className='btn  text-hover-dark btn-cancelar'>
                    Cancelar
                  </button>
                </div>
              </div>
              {isLoading && <Cargando mensaje='Actualizando contraseña' />}
            </form>
          </div>
          <div className='col-sm p-5'>
            <Alert
              mensaje='Debe tener mínimo 8 caracteres y máximo 15, al menos dos caracteres en minúsculas, dos
            mayúsculas, dos numéricos y dos especiales. No incluyas tu nombre, apellido o correo
            electrónico.'
              titulo='Cómo debe ser tu contraseña'
              fs={4}
              anexo='Caracteres permitidos: !@#$%^&*()_+'
            />
          </div>
        </div>
      </div>
      <div></div>
    </>
  )
}
